export default {"src":"/_next/static/media/31-icon.6e6f3c3f.svg","height":46,"width":43,"blurWidth":0,"blurHeight":0};